<script setup lang="ts">
import { useTheme } from 'vuetify'

const theme = useTheme()

theme.global.name.value = 'lytningDark'
</script>

<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<style scoped>
/* shop.co.zm Admin Portal Styles */
</style>
